import { api, authHeader } from "../configs/axiosConfigs";

const BASE = "/SLN/Customer/PaymentGateway";

const PAYMENT_RESULT_PATH = "/SLN/Customer/payment-result";

/** مبدأ SPA — هرگز از API_URL به‌عنوان origin استفاده نمی‌شود. */
const getFrontendOrigin = () => {
  const apiBase = (window.globalConfig?.API_URL || "").replace(/\/$/, "");
  const origin = window.location.origin.replace(/\/$/, "");

  if (apiBase && origin === apiBase) {
    const port = process.env.PORT || "4030";
    return `http://localhost:${port}`;
  }

  return origin;
};

/** آدرس بازگشت از درگاه — باید با route فرانت هم‌خوان باشد. */
export const getPaymentReturnUrl = () =>
  `${getFrontendOrigin()}${PAYMENT_RESULT_PATH}`;

/** Fix legacy API-host TestGateway links (2230/45100) → SPA origin (4030). */
export const normalizePaymentRedirectUrl = (url) => {
  if (!url || typeof url !== "string") return url;

  try {
    const parsed = new URL(url, window.location.origin);
    if (!parsed.pathname.includes("/SLN/PaymentGateway/TestGateway")) {
      return url;
    }

    const apiPort = (() => {
      try {
        return new URL((window.globalConfig?.API_URL || "").replace(/\/$/, "") + "/").port;
      } catch {
        return "";
      }
    })();

    const isApiHost =
      parsed.port === "2230" ||
      parsed.port === "45100" ||
      (apiPort && parsed.port === apiPort);

    if (!isApiHost) return url;

    return `${getFrontendOrigin()}${parsed.pathname}${parsed.search}`;
  } catch {
    return url;
  }
};

const PaymentGatewayApi = {
  startInvoicePayment: async (invoiceId, returnUrl) => {
    const response = await api.request({
      url: `${BASE}/StartInvoicePayment/${invoiceId}`,
      method: "POST",
      headers: authHeader(),
      data: {
        provider: "Mellat",
        returnUrl: returnUrl || getPaymentReturnUrl(),
      },
    });
    return response.data;
  },

  getPaymentResult: async (sessionId) => {
    const response = await api.request({
      url: `${BASE}/PaymentResult/${sessionId}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getInvoicePaymentStatus: async (invoiceId) => {
    const response = await api.request({
      url: `${BASE}/InvoicePaymentStatus/${invoiceId}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getUnpaidInvoicesSummary: async () => {
    const response = await api.request({
      url: `${BASE}/UnpaidInvoicesSummary`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getRequestsPaymentSummary: async () => {
    const response = await api.request({
      url: `${BASE}/RequestsPaymentSummary`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getRequestInvoicesPaymentPanel: async (requestInfoId) => {
    const response = await api.request({
      url: `${BASE}/RequestInvoicesPaymentPanel/${requestInfoId}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },
};

export default PaymentGatewayApi;
